import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import { motion } from 'framer-motion';

const NavbarItems = () => {
  return (
    <motion.ul animate={{ y: 10 }} className={styles.ul}>
      <li className={styles.li}>
        <Link className={styles.welcome_nav_text_color} to="/">
          Hem
        </Link>
      </li>
      <li className={styles.li}>
        <Link className={styles.project_nav_text_color} to="/projects">
          Projekt
        </Link>
      </li>
      <li className={styles.li}>
        <Link className={styles.expertise_nav_text_color} to="/expertise">
          Kunskaper
        </Link>
      </li>
      <li className={styles.li}>
        <Link className={styles.about_nav_text_color} to="/about">
          Om
        </Link>
      </li>
      <li className={styles.li}>
        <Link className={styles.contact_nav_text_color} to="/contacts">
          Kontakt
        </Link>
      </li>
    </motion.ul>
  );
};

export default NavbarItems;
